
// src/pages/checagens/ChecagemImovelWorkPage.tsx
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ChecklistCard from '../../components/checagens/ChecklistCard';
import TarefasList from '../../components/checagens/TarefasList';
import TimelineEventos from '../../components/checagens/TimelineEventos';
import { useChecagem, useChecagemImovel, useFinalizarChecagem } from '../../hooks/useChecagens';
import Loading from '../../components/Loading';
import ErrorToast from '../../components/ErrorToast';
import ConfirmDialog from '../../components/ConfirmDialog';
import './ChecagemImovelWorkPage.css';

const ChecagemImovelWorkPage: React.FC = () => {
  const { ciid } = useParams<{ ciid: string }>();
  const checagemImovelId = Number(ciid);
  const navigate = useNavigate();

  const { data: checagemImovel, isLoading, error } = useChecagemImovel(checagemImovelId);
  const { data: checagem } = useChecagem(checagemImovel?.checagem_id);
  const [isFinalizarModalOpen, setFinalizarModalOpen] = useState(false);
  const finalizarChecagemMutation = useFinalizarChecagem();

  const handleFinalizar = () => {
    if (checagemImovel) {
      finalizarChecagemMutation.mutate(checagemImovel.checagem_id, {
        onSuccess: () => {
          setFinalizarModalOpen(false);
        }
      });
    }
  };

  if (isLoading) return <Loading />;
  if (error) return <ErrorToast message={error.message} onClose={() => {}} />;

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="header-left">
            <button onClick={() => { if (checagemImovel) navigate(`/checagens/${checagemImovel.checagem_id}`) }} className="button-secondary">Voltar</button>
        </div>
        <div className="header-center">
          <h1 className="page-title">Trabalhando no Imóvel {checagemImovel?.imovel?.numero_contribuinte}</h1>
          <p className="page-subtitle">Checagem: {checagemImovel?.checagem_id} / Imóvel ID: {checagemImovel?.imovel_id}</p>
        </div>
        <div className="header-right">
          {checagem?.status !== 'finalizada' &&
            <button onClick={() => setFinalizarModalOpen(true)} className="button">Finalizar Checagem</button>
          }
        </div>
      </div>
      
      <div className="work-page-layout">
        <div className="work-column">
          <ChecklistCard checagemImovelId={checagemImovelId} />
          <TarefasList checagemImovelId={checagemImovelId} />
        </div>
        <div className="timeline-column">
          {checagemImovel && <TimelineEventos 
            imovelId={checagemImovel.imovel_id} 
            checagemImovelId={checagemImovel.id}
            resultadoCaptacao={checagemImovel.resultado_captacao} 
          />}
        </div>
      </div>

      {isFinalizarModalOpen && (
        <ConfirmDialog 
          message="Tem certeza que deseja finalizar esta checagem?"
          onConfirm={handleFinalizar}
          onCancel={() => setFinalizarModalOpen(false)}
        />
      )}
    </div>
  );
};

export default ChecagemImovelWorkPage;
